import { SvgIcon, SvgIconProps } from "@mui/material";

export const WindowResizeRightIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m8 14 2-2-2-2"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M11 21H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h3"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M16 3a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-2V3h2Z"
        clip-rule="evenodd"
      />
    </svg>
  </SvgIcon>
);
